import { Box, Collapse, Typography } from '@mui/material'
import { ChevronDownIcon, ChevronRightIcon } from '~components/icons'
import { COLORS } from '~theme/colors'
import type { ReactNode } from 'react'

const groupRowSx = {
  py: 1.5,
  px: 2,
  pl: 5,
  cursor: 'pointer',
  borderBottom: 1,
  borderColor: COLORS.greys.light,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
}

const childRowSx = {
  py: 1.5,
  px: 2,
  pl: 8,
  cursor: 'pointer',
  borderBottom: 1,
  borderColor: COLORS.greys.light,
}

interface ExpandableGroupRowProps {
  label: ReactNode
  isExpanded: boolean
  isSelected: boolean
  onClick: () => void
  children?: ReactNode
}

export function ExpandableGroupRow({
  label,
  isExpanded,
  isSelected,
  onClick,
  children,
}: ExpandableGroupRowProps) {
  return (
    <Box>
      <Box
        onClick={(e) => {
          e.stopPropagation()
          onClick()
        }}
        sx={{
          ...groupRowSx,
          bgcolor: isSelected ? COLORS.secondary.lightBlue : 'transparent',
          '&:hover': {
            bgcolor: isSelected
              ? COLORS.secondary.lightBlue
              : COLORS.secondary.blueTint,
          },
        }}
      >
        <Box>
          {isExpanded ? (
            <ChevronDownIcon width={14} height={14} />
          ) : (
            <ChevronRightIcon width={14} height={14} />
          )}
        </Box>
        <Typography variant="paragraph2">{label}</Typography>
      </Box>

      <Collapse in={isExpanded}>
        <Box>{children}</Box>
      </Collapse>
    </Box>
  )
}

interface ChildItemRowProps {
  children: ReactNode
  isSelected: boolean
  onClick: () => void
}

export function ChildItemRow({
  children,
  isSelected,
  onClick,
}: ChildItemRowProps) {
  return (
    <Box
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
      sx={{
        ...childRowSx,
        bgcolor: isSelected ? COLORS.secondary.notificationBlue : 'transparent',
        '&:hover': {
          bgcolor: isSelected
            ? COLORS.secondary.notificationBlue
            : COLORS.secondary.blueTint,
        },
      }}
    >
      {children}
    </Box>
  )
}
